/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it handle RNA or ambiguous bases?`)
};

const es_tm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Admite ARN o bases ambiguas?`)
};

const de_tm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitet es RNA oder mehrdeutige Basen?`)
};

const nl_tm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werkt het met RNA of ambigue basen?`)
};

const fr_tm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère-t-il l'ARN ou les bases ambiguës ?`)
};

const it_tm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisce l'RNA o basi ambigue?`)
};

const pt_br2_tm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ela trata RNA ou bases ambíguas?`)
};

const pt_tm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trata ARN ou bases ambíguas?`)
};

const ja_tm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RNAやあいまいな塩基には対応していますか？`)
};

const zh_tm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是否支持 RNA 或简并碱基？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_faq_q4", locale)
	if (locale === "en") return en_tm_faq_q4(inputs)
	if (locale === "es") return es_tm_faq_q4(inputs)
	if (locale === "de") return de_tm_faq_q4(inputs)
	if (locale === "nl") return nl_tm_faq_q4(inputs)
	if (locale === "fr") return fr_tm_faq_q4(inputs)
	if (locale === "it") return it_tm_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_tm_faq_q4(inputs)
	if (locale === "pt") return pt_tm_faq_q4(inputs)
	if (locale === "ja") return ja_tm_faq_q4(inputs)
	return zh_tm_faq_q4(inputs)
};